export enum EntityConcernType {
    Green = 1,
    Yellow = 2,
    Red = 3,
}

export const EntityConcernTypeOptions = [
    {
        id: EntityConcernType.Green,
        name: 'Green',
    },
    {
        id: EntityConcernType.Yellow,
        name: 'Yellow',
    },
    {
        id: EntityConcernType.Red,
        name: 'Red',
    },
];
